import tabStyles from "../../../styles/UI/viewTab.module.css";
import IconButtonComponent from "../buttons/IconButton";
import { ReactComponent as XIcon } from "../../../assets/icons/x_grey.svg";
import { ReactElement } from "react";

const ViewTab = ({
  displayedTabName,
  selected,
  onClick,
  tabTypeName,
  fade,
  onClose,
  icon,
}: {
  displayedTabName: string;
  selected: string;
  onClick: (displayedTabName: string) => void;
  tabTypeName: string;
  fade?: boolean;
  onClose?: () => void;
  icon?: ReactElement;
}) => {
  return (
    <button
      onClick={() => onClick(displayedTabName)}
      className={`${tabStyles.viewTab} ${
        selected === tabTypeName ? tabStyles.viewTabSelected : tabStyles.viewTab
      } ${fade && "fade-in-tab"}`}
      title={displayedTabName}
    >
      {icon && icon}
      <span className={tabStyles.viewTabSpan}>{displayedTabName}</span>
      {onClose && selected === tabTypeName && (
        <IconButtonComponent
          ariaLabel={displayedTabName}
          id="close_edit"
          onClick={onClose}
          icon={<XIcon height={20} />}
          height={16}
          width={16}
        />
      )}
    </button>
  );
};
export default ViewTab;
